import { X } from 'lucide-react';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/language-switcher';

export default function FighterConsentAndResponsibilityAgreement() {
  const navigate = useNavigate()
  const { t } = useTranslation();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  }

  return (
    <div className='page-size flex-center p-4 items-start justify-start gap-4'>
      <div className='flex flex-row justify-between items-center w-[calc(100vw-2rem)] top-2 left-4 p-2 '>
        <LanguageSwitcher />
        <div className="flex-1" />
        <button className="btn btn-ghost btn-md btn-square" onClick={handleClose}>
          <X />
        </button>
      </div>
      <p className='pb-2 font-bold text-lg'>{t('fighterConsent.title')}</p>
      <p>{t('fighterConsent.acknowledgment')}</p>
      <p>{t('fighterConsent.assumptionOfRisk')}</p>
      <p>{t('fighterConsent.medicalCondition')}</p>
      <p>{t('fighterConsent.trainingAndPreparation')}</p>
      <p>{t('fighterConsent.complianceWithRules')}</p>
      <p>{t('fighterConsent.releaseOfLiability')}</p>
      <p>{t('fighterConsent.insurance')}</p>
      <p>{t('fighterConsent.mediaRelease')}</p>
      <p>{t('fighterConsent.confirmation')}</p>

      <p className='pb-2 pt-4 font-bold text-lg'>{t('fighterConsent.eventParticipationTitle')}</p>
      <ul className='list-disc list-outside pl-5 flex flex-col gap-2'>
        <li>{t('fighterConsent.eventInfo')}</li>
        <li>{t('fighterConsent.withdrawalPolicy')}</li>
        <li>{t('fighterConsent.refundPolicy')}</li>
        <li>{t('fighterConsent.matchmaking')}</li>
        <li>{t('fighterConsent.minorPolicy')}</li>
      </ul>
      <p className='pt-2'>{t('fighterConsent.closing')}</p>
    </div>
  )
}
